import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { WAITING ,MINIMINZE,PINE_LAB_TERMINAL} from 'src/defaultImages.js';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { PineCancelPopUpEnum, PineLabsConsts, PineLabsEnum, PineLabsTimeOut } from 'src/app/common/enums/pinelabs.enum';
import { Subject, Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { TranslateService } from '@ngx-translate/core';
import { PineLabService } from 'src/app/common/services/pine-lab.service';
import { CurrencyService } from 'src/app/util/currency.service';
@Component({
  selector: 'app-waiting-payment',
  templateUrl: './waiting-payment.component.html',
  styleUrls: ['./waiting-payment.component.css'],
})
export class WaitingPaymentComponent implements OnInit {
  @Input() orderId:string;
  @Input() ptrId:string;
  @Input() pmtId:string;
  @Input() amount:number;
  @Input() mergedOrderArr:Array<any>;
  @Input() isSettleBillCall:boolean = false;
  @Input() isMaxiMize:boolean = false;
  @Input() reDeadlineTime:number = 0;
  @Input() reStartTime:number = 0;
  subscription = new Subscription();
  translationText:any;
  deadlineDate: any;
  totalTime: number = PineLabsConsts.DEFAULT_MINUTES * PineLabsConsts.DEADLINE_ONE_MINUTE; // Total time in seconds 
  intervalId: any; // Timer interval ID
  percentageElapsed: number = 0; // Percentage elapsed 
  isPollngOn:number = 0;
  startTime:number = 0;
  deadlineTime:number = 0;

  showInfoText:boolean=true;
  showStaffGuide:boolean=true;
  images = {
    WAITING: WAITING,
    MINIMINZE:MINIMINZE,
    PINE_LAB_TERMINAL:PINE_LAB_TERMINAL
  };
  staffGuideModal:any;
  private ngUnsubscribe = new Subject();
  currency:string='';
  constructor(
    private _modalRef: NzModalRef,
    private _cdr: ChangeDetectorRef,
    private _modalService: NzModalService,
    private _apiService: ApiService,
    private _messageService: MessageService,
    private _localStorage: LocalStorageService,
    public _translateService: TranslateService,
    public _pineLabService:PineLabService,
    private _curr: CurrencyService,
  ) {
    this.currency = this._curr.getCurrency();
  }

  ngOnInit() {
    this.subscription.add(
      this._translateService.get(['SHARED']).subscribe((translation) => {
        this.translationText = translation.SHARED;
      })
    );
    setTimeout(()=>{this.showInfoText = false;}, 20000);
    const startDate = new Date();
    this.startTime = this.isMaxiMize ? this.reStartTime : startDate.getTime();
    
    const plMinutes = PineLabsConsts.DEFAULT_MINUTES;
    const deadlineMinutes = plMinutes * PineLabsConsts.DEADLINE_ONE_MINUTE;
    this.deadlineDate = new Date(this.startTime + deadlineMinutes);
    this.deadlineTime = this.deadlineDate.getTime();
    this.totalTime = (this.deadlineTime - this.startTime);
    this.startTimer();
    if(!this.isMaxiMize){
      this._pineLabService.storePLData({
        orderId:this.orderId,
        ptrId:this.ptrId,
        pmtId:this.pmtId,
        amount:this.amount,
        startTime:this.startTime,
        deadlineTime:this.deadlineTime
      },this.mergedOrderArr,this.isSettleBillCall);
    }
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  startTimer(): void { 
    this.intervalId = setInterval(() => {
      const currentTime = new Date().getTime() - this.startTime;
      if (currentTime < this.totalTime) {
        this.percentageElapsed = (currentTime / this.totalTime) * PineLabsConsts.HUNDERED;
        this._cdr.detectChanges();
      } else {
        this.stopTimer({ data: PineLabsTimeOut.EXPIRED });
        // Perform any actions when the timer reaches 0
      }
    }, 1000); // Update every 1 second
  }

  stopTimer(data?): void {
    clearInterval(this.intervalId);
    this.dismissModal(data);
  }
  miniMize(): void {
    if(this.intervalId){
      clearInterval(this.intervalId);
    }
    this.dismissModal({ data: PineLabsEnum.POP_UP_MINIMIZE });
  }
  dismissModal(data?) {
    if(this.staffGuideModal){
      this.staffGuideModal.close();
    }
    this._modalRef.close(data);
  }
  async cancelPayment() {
    const { CancelPaymentComponent } = await import(
      /* webpackPrefetch: true */ '../cancel-payment/cancel-payment.component'
    );
    const modal = this._modalService.create({
      nzContent: CancelPaymentComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzBodyStyle: { padding: '0' },
      nzFooter: null,
      nzWidth: 500,
      nzCentered: true,
      nzComponentParams: {
        orderId: this.orderId,
        ptrId:this.ptrId,
        pmtId:this.pmtId,
        amount:this.amount
      },
    });
    modal.afterClose.subscribe((result: any) => {
      if ((result || {}).status === PineCancelPopUpEnum.CANCEL_SUCCESS) {
        this.stopTimer({ data: PineLabsEnum.PAYMENT_CANCELLED });
      } else if((result || {}).status === PineCancelPopUpEnum.CANCEL_REJECTED) {
        this._messageService.showError(this.translationText.CANCEL_ERROR_TEXT);
      }
    });
  }

  hideStaffGuide(){
    this.showStaffGuide = false;
  }
  async yesIwantToSee(){ 
    const { StaffGuidePopupComponent } = await import(
      /* webpackPrefetch: true */ '../staff-guide-popup/staff-guide-popup.component'
    );
    this.staffGuideModal = this._modalService.create({
      nzContent: StaffGuidePopupComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzBodyStyle: { height: 'auto', width: 'auto' },
      nzFooter: null,
      nzCentered: true,
      nzComponentParams: {},
    });
  }
}
